module.exports = __webpack_public_path__ + "static/img/1.5b157ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/1.png
// module id = S3/c
// module chunks = 1